import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowDiagonalLeftUpOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path d="M11.5 2.5h-9v9h1.4V4.891l8.6 8.609 1-1-8.61-8.6h6.61z" fill="currentColor" />
            </g>
        </svg>
    )
);
ArrowDiagonalLeftUpOutlinedSize16Glyph.displayName = 'ArrowDiagonalLeftUpOutlinedSize16Glyph';
